import appConfig from '../../../config/app-config';

// API Configuration
export const STRUCTURING_API = {
    url: appConfig.apis.convertXmlApiEnv.address,
    key: appConfig.apis.convertXmlApiEnv.key,
};

// Routes
export const STRUCTURING_ROUTES = {
    list: '/structuring/operations/0/20',
    create: '/structuring/operation',
    view: (id: string) => `/structuring/operation/view/${id}`,
} as const;

// Formatters
export const formatCurrency = (value: number): string => {
    return new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL'
    }).format(value);
};

export const formatDate = (dateString: string): string => {
    if (!dateString) return '';
    const normalized = dateString.includes('T') ? dateString : dateString.replace(' ', 'T');
    const date = new Date(normalized);
    if (isNaN(date.getTime())) return dateString;
    return date.toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
    });
};

export const formatBytes = (bytes: number): string => {
    return `${(bytes / 1024).toFixed(2)} KB`;
};

// Status helpers
export const OperationStatus = {
    COMPLETED: 'completed',
    PROCESSING: 'processing',
    FAILED: 'failed',
    CLOSED: 'closed',
} as const;

export type OperationStatusType = typeof OperationStatus[keyof typeof OperationStatus];

export const getStatusColor = (status: string): 'green' | 'yellow' | 'red' | 'gray' => {
    switch (status) {
        case OperationStatus.COMPLETED:
            return 'green';
        case OperationStatus.PROCESSING:
            return 'yellow';
        case OperationStatus.FAILED:
            return 'red';
        default:
            return 'gray';
    }
};

export const getStatusLabel = (status: string): string => {
    switch (status) {
        case OperationStatus.COMPLETED:
            return 'Concluído';
        case OperationStatus.PROCESSING:
            return 'Processando';
        case OperationStatus.FAILED:
            return 'Falhou';
        default:
            return status;
    }
};

// Breadcrumbs
export const STRUCTURING_BREADCRUMBS = {
    operations: { label: 'Operações', url: STRUCTURING_ROUTES.list },
    operationDetail: { label: 'Detalhes da operação', url: '#' },
    newOperation: { label: 'Nova operação', url: '#' },
    structuring: { label: 'Estruturação', url: STRUCTURING_ROUTES.list },
} as const;
